import React, { PropsWithChildren } from "react";

import { SupText } from "@repo/core-ui";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

interface PortfolioRewardsNavItemProps {
  isActive?: boolean;
  activeClass?: string;
  link: string;
}

export default function LayoutNavBarItem({ activeClass, isActive, link, children }: PropsWithChildren<PortfolioRewardsNavItemProps>) {
  return (
    <Link
      href={link}
      className={twMerge(
        "group flex items-center space-x-2 self-stretch border-b-2 border-transparent px-2 text-neutral-900",
        isActive && (activeClass ?? "border-primary-700 text-primary-900 shadow-[0_0_8px_0_primary-50] hover:shadow-[0_0_8px_0_primary-50]"),
        isActive && "cursor-default"
      )}
    >
      <div className="flex w-max items-center justify-start gap-1">
        <SupText as="div" variant="button" className={twMerge("group-hover:font-bold group-hover:text-primary-900", isActive && "font-bold")}>
          {children}
        </SupText>
      </div>
    </Link>
  );
}
